import { createJoinApi } from '@sgcmpteltd/uikit-next/utils/url/join/private';

import {
  SERVER_SGCM_API_ORIGIN,
  SERVER_SGCM_MARKETPLACE_API_ORIGIN,
} from '@/configs/private-url';

import type {
  ArticleApiVersion,
  EvApiVersion,
  MiscApiVersion,
  NewCarApiVersion,
} from './types';

export const joinApiEv = createJoinApi<EvApiVersion>({
  origin: SERVER_SGCM_API_ORIGIN ?? '',
  prefixPath: '/api-ev/api',
});

export const joinApiMember = createJoinApi<never>({
  origin: SERVER_SGCM_API_ORIGIN ?? '',
  prefixPath: '/api-member',
});

export const joinApiMisc = createJoinApi<MiscApiVersion>({
  origin: SERVER_SGCM_API_ORIGIN ?? '',
  prefixPath: '/api-misc/api',
});

export const joinApiArticle = createJoinApi<ArticleApiVersion>({
  origin: SERVER_SGCM_API_ORIGIN ?? '',
  prefixPath: '/api-article/api',
});

export const joinApiNewCar = createJoinApi<NewCarApiVersion>({
  origin: SERVER_SGCM_API_ORIGIN ?? '',
  prefixPath: '/api-newcar/api',
});

export const joinApiMarketplace = createJoinApi<never>({
  origin: SERVER_SGCM_MARKETPLACE_API_ORIGIN ?? '',
  prefixPath: '/api',
});
